/**
 * Tag Directive
 * @module v-imagelazy
 */

/**
 * Vue Tag directive declaration.
 */
export const imagelazy = {
    bind: (el, binding) => {
      const element = el;
      const rawHtml = binding.value;
      // Create a temporary container to manipulate the HTML
      const tempDiv = document.createElement('div');
      tempDiv.innerHTML = rawHtml;
      // Add 'lazyload' class and update img attributes
      const images = tempDiv.querySelectorAll('img');
      images.forEach(img => {
        if (!img.classList.contains('lazyload')) {
          img.classList.add('lazyload');
        }
        // Move src to data-src
        if (img.hasAttribute('src')) {
          img.setAttribute('data-src', img.getAttribute('src'));
          img.removeAttribute('src');
        }
      });
      // Set the modified HTML content
      element.innerHTML = tempDiv.innerHTML;
    },
  
    update: (el, binding) => {
      if (binding.oldValue !== binding.value) {
        const element = el;
        const rawHtml = binding.value;
        const tempDiv = document.createElement('div');
        tempDiv.innerHTML = rawHtml;
        const images = tempDiv.querySelectorAll('img');
        images.forEach(img => {
          if (!img.classList.contains('lazyload')) {
            img.classList.add('lazyload');
          }
          // Move src to data-src
          if (img.hasAttribute('src')) {
            img.setAttribute('data-src', img.getAttribute('src'));
            img.removeAttribute('src');
          }
        });
        element.innerHTML = tempDiv.innerHTML;
      }
    }
  };
  